export const packageId = "fxmaster";
export const MAX_EDGES = 64;
export const ALL_LEVELS_SELECTION = "__fxmaster_all_levels__";
export const API_EFFECT_ID_PREFIX = "apiMacro_";
export const API_EFFECT_UPDATE_OPTIONS_FLAG = "_apiEffectsUpdateOptions";
